const EventMyWorkChangePositions = function(uid, data, sid) {
    this.data = data;
    this.uid = uid;
    this.fromSID = sid;
};

EventMyWorkChangePositions.prototype.validate = function(){
    return true;
};

EventMyWorkChangePositions.prototype.process = function(){
    //do nothing, sort positions are handled in another way now
    /*if (!gd.session.myWork) return;

    // do not process event for user who initialed updated
    if (this.fromSID === gd.sessionId) {
        // console.log("same user -> ignore");
        return false;
    }

    const arrIds = this.data;

    let havePositionChanges = false;
    arrIds.forEach((id,key)=>{
        const myWorkItem = gd.session.myWork.get(id);
        if (myWorkItem && myWorkItem.position !== key+1) havePositionChanges = true;
    });

    if (!havePositionChanges) return;

    arrIds.forEach((id,key)=>{
        gd.session.myWork.get(id).set({position: key+1},{silent:true});
    });

    gd.session.myWork.trigger("reset");
    gd.bus.triggerEvent('gd.session.myWork:reset');*/

    return true;
};


module.exports = EventMyWorkChangePositions;

